module.exports = ":host .dashboard {\n  position: relative; }\n  :host .dashboard .more-results {\n    position: absolute;\n    right: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/storyboard-dashboard/storyboard-dashboard.component.scss
// module id = ./src/app/shared/components/storyboard-dashboard/storyboard-dashboard.component.scss
// module chunks = main